// extracted by mini-css-extract-plugin
var _1 = "sender_container__BbTnU";
var _2 = "sender_names__pv3WK";
export { _1 as "container", _2 as "names" }
